import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function Prospectus() { 
  useEffect(() => {
    document.title = 'Prospectus -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>Academics</li>
                <li>Prospectus</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Prospectus</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
               <p>The school endeavours to inculcate discipline in all the pupils
               by continuously imparting appropriate training to become law
               abiding and socially useful citizens who will enlighten and help
               others by their virtues. Hence it is imperative for all concerned to
               follow the rules and regulations of the school. The attention of
               parents is drawn to the importance of being acquainted with them.
               Parents agree to follow the rules and regulations of the school
               by signing the application form for registration. The school
               diary distributed to students every year contains rules and
               regulations and the school calender for the academic year.
               Parents are requested to plan their activities and programmes
               accordingly to avoid inconvenience.</p>
               <p>Your co-operation is required for the success of our activities and
               for your benefit.</p>
               </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default Prospectus;
